<template>
  <p-container>
    <p-row>
      <p-row align-center>
        <p-button tertiary @click="back">
          <p-icon>
            keyboard_backspace
          </p-icon>
        </p-button>
        <h2>{{ $t('core.page.contactidmapping.page.title') }} (Id:{{ id }})</h2>
      </p-row>
      <p-col xs12>
        <p-request-alert v-model="requestError"></p-request-alert>
      </p-col>
      <p-progress-linear v-if="isLoading" class="my-2" indeterminate></p-progress-linear>
      <p-col xs6>
        <p-card>
          <h4 class="mb-2">
            {{ $t('core.page.contactidmapping.label.crm') }}
          </h4>
          <p-text-field v-model="contactIdMappingDetail.crmId" :label="$t('core.page.contactidmapping.properties.crmId')"></p-text-field>
          <p-select
            v-model="contactIdMappingDetail.crmStateId"
            clearable
            :label="$t('core.page.contactidmapping.properties.crmStateName')"
            :items="crmStatus"
          ></p-select>
          <p-row align-end>
            <p-col justify-end>
              <p-button class="mt-4" @click="patchContactIdMapping(contactIdMappingDetail.id, contactIdMappingDetail.crmId, contactIdMappingDetail.crmStateId)">
                {{ $t('core.app.save') }}
              </p-button>
            </p-col>
          </p-row>
        </p-card>
        <p-row>
          <p-col>
            <p-alert :value="successMessage" type="success">
              {{ successMessage }}
            </p-alert>
          </p-col>
        </p-row>
      </p-col>
      <p-col xs6>
        <p-card>
          <h4 class="mb-2">
            {{ $t('core.page.contactidmapping.label.foreignAppSystem') }} {{ appSystem.name }}
          </h4>
          <span>{{ $t('core.page.contactidmapping.properties.foreignId') }}: {{ contactIdMappingDetail.foreignId }}</span>
        </p-card>
      </p-col>
      <p-card>
        <p-row column dense>
          <h4>{{ $t('core.page.contactidmapping.label.mapping') }}</h4>
          <span>{{ $t('core.page.contactidmapping.properties.mappingStateName') }}: {{ contactIdMappingDetail.mappingStateName }} ({{ contactIdMappingDetail.mappingStateId }})</span>
          <span>{{ $t('core.page.contactidmapping.properties.mappingStateReason') }}: {{ contactIdMappingDetail.mappingStateReason }}</span>
          <span>{{ $t('core.page.contactidmapping.properties.created') }}: {{ $format.localDateAndTime(contactIdMappingDetail.created) }}</span>
          <span>{{ $t('core.page.contactidmapping.properties.modified') }}: {{ $format.localDateAndTime(contactIdMappingDetail.modified) }}</span>
        </p-row>
      </p-card>
    </p-row>
    <p-row>
      <p-card>
        <p-row>
          <p-col xs12 md6>
            <h3>{{ $t('core.page.contactidmapping.properties.currentContactData') }}</h3>
            <p v-html="currentContactDataJsonHtml"></p>
          </p-col>
          <p-col xs12 md6>
            <h3>{{ $t('core.page.contactidmapping.properties.previousContactData') }}</h3>
            <p v-html="previousContactDataJsonHtml"></p>
          </p-col>
        </p-row>
      </p-card>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import AppSystemResourceViewModel from '../../../../services/v1/viewModel/resource/AppSystemResourceViewModel';
  import ContactIdMappingResourceViewModel from '../../../../services/v1/viewModel/resource/ContactIdMappingResourceViewModel';
  import PatchContactIdMappingRequestViewModel from '../../../../services/v1/viewModel/request/ContactIdMappings/PatchContactIdMappingRequestViewModel';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      isLoading: false,
      isRefreshing: false,
      successMessage: undefined as any,
      requestError: undefined as any,
      appSystem: new AppSystemResourceViewModel() as AppSystemResourceViewModel,
      contactIdMappingDetail: {} as ContactIdMappingResourceViewModel,
      id: Number as unknown | undefined,
      crmStatus: [] as {}[],
    }),
    computed: {
      lastUpdated() {
        return this.$format.localDateAndTime(this.contactIdMappingDetail.modified ?? this.contactIdMappingDetail.created!);
      },
      previousContactDataJsonHtml() {
        return JSON.stringifyToHTML(this.contactIdMappingDetail?.previousContactData);
      },
      currentContactDataJsonHtml() {
        return JSON.stringifyToHTML(this.contactIdMappingDetail?.currentContactData);
      },
    },
    async mounted() {
      this.isLoading = true;
      try {
        const { id } = this.$router.currentRoute.params;
        this.id = id;
        const response = await this.$service.api.core.contactIdMappings.getContactIdMappingById(id as any);
        this.contactIdMappingDetail = response;
        const responseAppSystems = await this.$service.v1.api.core.appSystem.getAppSystem();
        const appSystems = responseAppSystems.items;
        this.appSystem = appSystems.find((a: { id: any; }) => a.id === this.contactIdMappingDetail.foreignAppSystemId) ?? new AppSystemResourceViewModel();
        this.crmStatus = [
          { id: 0, caption: 'Unchanged' },
          { id: 1, caption: 'CrmInserted' },
          { id: 2, caption: 'CrmUpdated' },
          { id: 3, caption: 'CrmDeleted' },
        ];
      } catch (error: any) {
        this.requestError = error;
      }
      this.isLoading = false;
    },
    methods: {
      async patchContactIdMapping(id: number | undefined, crmId: string | undefined, crmStateId: number | undefined) {
        this.isRefreshing = true;
        try {
          const req = new PatchContactIdMappingRequestViewModel();
          req.id = id;
          req.crmId = crmId;
          req.crmStateId = crmStateId;
          await this.$service.v1.api.core.contactIdMappings.patchContactIdMapping(id!, req);
          this.successMessage = 'Successfully Updated';
        } catch (error: any) {
          this.requestError = error;
          Vue.$log.error(error);
        }
        this.isRefreshing = false;
      },
      back() {
        this.$router.back();
      },
    },
  });
</script>
